// utils/NavigationClient.js
import { NavigationClient } from "@azure/msal-browser";

export class CustomNavigationClient extends NavigationClient {
  constructor(navigate) {
    super();
    this._navigate = navigate;
    // fallback if not set in index.js
    this.basename = window.__BASENAME__ || (process.env.PUBLIC_URL && new URL(process.env.PUBLIC_URL, window.location.origin).pathname) || "";
    // ensure leading slash, no trailing slash (except root)
    if (this.basename !== "/" && this.basename.endsWith("/")) {
      this.basename = this.basename.slice(0, -1);
    }
  }

  async navigateInternal(url, options) {
    let relative;
    try {
      const parsed = new URL(url, window.location.href);
      relative = parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      // if url is already relative
      relative = url;
    }

    // If the relative path begins with the basename, strip it
    if (this.basename && relative.startsWith(this.basename)) {
      relative = relative.slice(this.basename.length) || "/";
    }

    // ensure it starts with "/" so react-router understands it
    if (!relative.startsWith("/")) relative = "/" + relative;

    if (options?.noHistory) {
      this._navigate(relative, { replace: true });
    } else {
      this._navigate(relative);
    }
    return false;
  }
}
